/**
 * Global Action File
 */

import { start } from '../slices/appSlice';
import {setTheme} from '../slices/themeSlice'

export const appInit = (value) => (dispatch) => dispatch(start(value));
export const manageTheme = (value) => (dispatch) => dispatch(setTheme(value));
